import React, { useState, useEffect } from 'react';
import axios from 'axios';

import { useMsal, useAccount } from "@azure/msal-react";
import { silentRequest } from "../../../authConfig";

import { useHistory, useLocation } from 'react-router-dom';

import { Controlled as CodeMirror } from 'react-codemirror2'

import {
  Stack,
  Icon,
  PrimaryButton,
  DefaultButton,
  Spinner,
  getTheme,
  MessageBar,
  MessageBarType,
  Dropdown,
  Separator,
  mergeStyleSets,
  DatePicker,
  DayOfWeek,
  TextField,
  Dialog,
  DialogFooter,
  DialogType,
} from '@fluentui/react';

import styled from 'styled-components';

import moment from 'moment-timezone';

// const API_URL = process.env.REACT_APP_API_URL;
const ADMIN_API_URL = process.env.REACT_APP_ADMIN_API_URL;

const theme = getTheme();

//Dropzone Style

const getColor = (props) => {
  if (props.isDragAccept) {
    return '#00e676';
  }
  if (props.isDragReject) {
    return '#ff1744';
  }
  if (props.isDragActive) {
    return '#2196f3';
  }
  //return '#eeeeee';
  //return 'rgb(194, 194, 194)';
  return 'rgb(134, 134, 134)';
}

const Container = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
    border-width: 2px;
    border-radius: 2px;
    border-color: ${props => getColor(props)};
    border-style: dashed;    
    background-color: #ffffff;
    color: #bdbdbd;
    outline: none;
    transition: border .24s ease-in-out;
    margin-top: 5px;
`;

// Processing dialog style
const spinnerStyles = {
  circle: {
    height: 24,
    width: 24,
    borderWidth: 4,
    marginTop: 25
  }
}

const spinnerStylesLoading = {
  circle: {
    height: 56,
    width: 56,
    borderWidth: 4,
  },
};

const cardStyle = {
  paddingLeft: 30,
  paddingRight: 30,
  paddingTop: 20,
  paddingBottom: 30,
  background: '#ffffff',
  marginLeft: '0',
  marginTop: '10px',
  boxShadow: theme.effects.elevation4,
};

const homeStyles = {
  border: 0,
  margin: 0,
  width: '100%',
  background: '#FAF9F8',
  position: 'relative',
};

const dropdownStyles = {
  dropdown: { width: 250 },
};

const controlClass = mergeStyleSets({
  control: {
    margin: '0 0 15px 0',
    maxWidth: '300px',
  },
  hover: {
    selectors: {
      '&:hover': { background: theme.palette.neutralLight },
    },
  },
});

const onFormatDate = (date, format) => {
  if (format === 'CE') {
    return `${date.getDate()}`.padStart(2, '0') + '/' + `${date.getMonth() + 1}`.padStart(2, '0') + '/' + date.getFullYear();
  } else {
    return `${date.getDate()}`.padStart(2, '0') + '/' + `${date.getMonth() + 1}`.padStart(2, '0') + '/' + (date.getFullYear() + 543);
  }
};

const SubscriptionsDetails = () => {

  const { instance, accounts } = useMsal();
  const account = useAccount(accounts[0] || {});

  const history = useHistory();
  const location = useLocation();

  const [data] = useState(location.state);

  const [oid, setOid] = useState('');
  const [companyId, setCompanyId] = useState('');
  const [companiesDetails, setCompaniesDetails] = useState({});

  const [packages, setPackages] = useState([])
  const [currentAddOnPackages, setCurrentAddOnPackages] = useState([])
  const [packagesAddOns, setPackagesAddOns] = useState([])
  const [monthsRemaining, setMonthsRemaining] = useState(0);


  const [getNewData, setGetNewData] = useState(false);
  const [billingsType, setBillingType] = useState('');
  const [enabled, setEnabled] = useState('-');
  const [accountData, setAccountData] = useState({});
  const [digitalSign, setDigitalSign] = useState('true');
  const [pdfa, setPdfa] = useState('true');
  const [attachXml, setAttachXml] = useState('false');
  const [ltv, setLtv] = useState('false');
  const [digitallySignedBy, setDigitallySignedBy] = useState('true');
  const [digitallySignedByBE, setDigitallySignedByBE] = useState('true');
  const [enableSms, setEnableSms] = useState('false');
  const [serviceProvider, setServiceProvider] = useState(null);

  const [ginkgoRequiredError, setGinkgoRequiredError] = useState(false);
  const [ginkgoApiKey, setGinkgoApiKey] = useState('');
  const [ginkgoShowPassword, setGinkgoShowPassword] = useState(false);

  // const [credits, setCredits] = useState(0);
  // const [topupAmount, setTopupAmount] = useState(0);
  // const [totalAmount, setTotalAmount] = useState(0);
  // const [lastTopup, setLastTopup] = useState(0);
  // const [lastTopupTime, setLastTopupTime] = useState('');

  // const [isLoading, setIsLoading] = useState(true);
  const [isLoadingGetNewData, setIsLoadingGetNewData] = useState(true);
  const [isLoadingSubmitBillingType, setIsLoadingSubmitBillingType] = useState(false);
  const [isLoadingSubmitBillingSubscription, setIsLoadingSubmitBillingSubscription] = useState(false);
  const [isLoadingSubmitEnabled, setIsLoadingSubmitEnabled] = useState(false);
  const [isLoadingSubmitDigitalSign, setIsLoadingSubmitDigitalSign] = useState(false);
  const [isLoadingSubmitPdfa, setIsLoadingSubmitPdfa] = useState(false);
  const [isLoadingSubmitAttachXml, setIsLoadingSubmitAttachXml] = useState(false);
  const [isLoadingSubmitLtv, setIsLoadingSubmitLtv] = useState(false);
  const [isLoadingDigitallySignedBy, setIsLoadingDigitallySignedBy] = useState(false);
  const [isLoadingDigitallySignedByBE, setIsLoadingDigitallySignedByBE] = useState(false);
  const [isLoadingSubmitEnableSms, setIsLoadingSubmitEnableSms] = useState(false);
  const [isLoadingSubmitServiceProvider, setIsLoadingSubmitServiceProvider] = useState(false);
  const [isLoadingSubmitPackage, setIsLoadingSubmitPackage] = useState(false);
  const [isLoadingSubmitNextPackage, setIsLoadingSubmitNextPackage] = useState(false);

  const [isLoadingSubmitPackageAddOn, setIsLoadingSubmitPackageAddOn] = useState(false)

  const [selectedBillingSubscription, setSelectedBillingSubscription] = useState('true')
  const [selectedBillingManual, setSelectedBillingManual] = useState('false')
  const [selectedMainPackage, setSelectedMainPackage] = useState('')
  const [selectedPackageStatus, setSelectedPackageStatus] = useState('-')
  const [currentMainPackage, setCurrentMainPackage] = useState(null)
  const [packageFrom, setPackageFrom] = useState(null)

  const [subscriptionDetails, setSubscriptionDetails] = useState(null)
  const [isLoadingChangePackage, setIsLoadingChangePackage] = useState(false)
  const [isLoadingSuspendSubscription, setIsLoadingSuspendSubscription] = useState(false)
  const [isLoadingActivateSubscription, setIsLoadingActivateSubscription] = useState(false)
  const [isLoadingCancelSubscription, setIsLoadingCancelSubscription] = useState(false)

  const [dialog, setDialog] = useState({
    isClick: false,
    title: "",
    onSubmit: () => null,
    cooldown: 10
  });

  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);

  useEffect(() => {
    if (companyId) {
      getPackage()
      getPackageAll()
      getCurrentPackageAddOn()
      getPackageAddOnAll()
    }
  }, [companyId]);
  
  useEffect(() => {

    console.log('useEffect accountData call!: ');

    console.log('accountData', accountData);

  }, [accountData]);

  useEffect(() => {
    if (!dialog.isClick) return;

    const interval = setInterval(() => {
      setDialog(prev => {
        if (prev.cooldown <= 0) {
          clearInterval(interval);
          return prev;
        }
        return {
          ...prev,
          cooldown: prev.cooldown - 1
        };
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [dialog.isClick]);

  useEffect(() => {
    console.log('useEffect getNewData call!');

    console.log('oid: ', oid);
    console.log('companyId: ', companyId);

    if (getNewData) {

      if (oid && companyId) {
        //console.log('useEffect data call! not undefied.');

        console.log('data: ', data);

        accountsOidList(oid);
        companiesDetailsCreatedByList(oid);

      }

      // setGetNewData(false);
      // setIsLoadingGetNewData(false);

    }

  }, [getNewData]);

  useEffect(() => {
    console.log('useEffect data call!: ', data);


    if (data !== undefined) {
      //console.log('useEffect data call! not undefied.');

      console.log('data: ', data);
      setCompanyId(data.companyId);
      setOid(data.oid)

      getSubscriptionDetails(data.companyId)

      accountsOidList(data.oid);
      companiesDetailsCreatedByList(data.oid);

      // setGetNewData(true);
      // setIsLoadingGetNewData(true);

    } else {
      history.push({ pathname: '/accounts/prepaid', state: {} });
    }


  }, [data]);

  async function getSubscriptionDetails(cid) {
    instance
    .acquireTokenSilent({ ...silentRequest, account: account })
    .then(async (tokenResponse) => {
        const responseSubscriptionDetails = await axios.get(`${ADMIN_API_URL}/subscriptions-details`, {
                                              headers: {
                                                Authorization: 'Bearer ' + tokenResponse.accessToken,
                                                cid: cid,
                                                // cid: 'c8d1bf6b-bf74-4608-ae46-34a282990e13',
                                              },
                                            })

        console.log('responseSubscriptionDetails', responseSubscriptionDetails)
        if (responseSubscriptionDetails.data) {
          setSubscriptionDetails(responseSubscriptionDetails.data)

        }
    })
    .catch((error) => {
      //Acquire token silent failure, and send an interactive request
      console.log(error);
      // instance.acquireTokenRedirect(silentRequest);
    });
  }

  async function handleChangePackage() {
    setIsLoadingChangePackage(true);

    setDialog((prev) => ({
      ...prev,
      isClick: false,
      title: "",
      onSubmit: () => null,
      cooldown: 10
    }))

    const _package = packages.find(_package => _package.key === selectedMainPackage) || null
    const _planId = _package?.payments?.paypal?.plan?.id
    
    instance
    .acquireTokenSilent({ ...silentRequest, account: account })
    .then(async (tokenResponse) => {
      const responseChangePackage = await axios.patch(`${ADMIN_API_URL}/payments/paypal/subscription`, { 
                                          planId: _planId,
                                          action: 'revise'
                                        }, 
                                        {
                                          headers: {
                                            Authorization: 'Bearer ' + tokenResponse.accessToken,
                                            cid: companyId,
                                          }
                                        })

      console.log("responseChangePackage", responseChangePackage)

      setIsLoadingChangePackage(false);
      getSubscriptionDetails(data.companyId)

      setShowSuccess(true);
    })
    .catch((error) => {
      //Acquire token silent failure, and send an interactive request
      console.log(error);

      setShowError(true);
      // instance.acquireTokenRedirect(silentRequest);
    });
  }

  async function handleCancelSubscription(_package, _plan) {
    setIsLoadingCancelSubscription(true);

    setDialog((prev) => ({
      ...prev,
      isClick: false,
      title: "",
      onSubmit: () => null,
      cooldown: 10
    }))

    instance
    .acquireTokenSilent({ ...silentRequest, account: account })
    .then(async (tokenResponse) => {
      const responseCancelSubscription = await axios.patch(`${ADMIN_API_URL}/payments/paypal/subscription`, { 
                                          action: 'cancel'
                                        }, 
                                        {
                                          headers: {
                                            Authorization: 'Bearer ' + tokenResponse.accessToken,
                                            cid: companyId,
                                          }
                                        })

      console.log("responseCancelSubscription", responseCancelSubscription)

      setIsLoadingCancelSubscription(false)
      getSubscriptionDetails(data.companyId)

      setShowSuccess(true);
    })
    .catch((error) => {
      //Acquire token silent failure, and send an interactive request
      console.log(error);

      setShowError(true);
      // instance.acquireTokenRedirect(silentRequest);
    });
  }

  async function handleSuspendSubscription(_package, _plan) {
    setIsLoadingSuspendSubscription(true);

    setDialog((prev) => ({
      ...prev,
      isClick: false,
      title: "",
      onSubmit: () => null,
      cooldown: 10
    }))

    instance
    .acquireTokenSilent({ ...silentRequest, account: account })
    .then(async (tokenResponse) => {
      const responseSuspendSubscription = await axios.patch(`${ADMIN_API_URL}/payments/paypal/subscription`, { 
                                          action: 'suspend'
                                        }, 
                                        {
                                          headers: {
                                            Authorization: 'Bearer ' + tokenResponse.accessToken,
                                            cid: companyId
                                          }
                                        })

      console.log("responseSuspendSubscription", responseSuspendSubscription)
    
      setIsLoadingSuspendSubscription(false);
      getSubscriptionDetails(data.companyId)

      setShowSuccess(true);
    })
    .catch((error) => {
      //Acquire token silent failure, and send an interactive request
      console.log(error);

      setShowError(true);
      // instance.acquireTokenRedirect(silentRequest);
    });
  }

  async function handleActivateSubscription(_package, _plan) {
    setIsLoadingActivateSubscription(true);

    setDialog((prev) => ({
      ...prev,
      isClick: false,
      title: "",
      onSubmit: () => null,
      cooldown: 10
    }))

    instance
    .acquireTokenSilent({ ...silentRequest, account: account })
    .then(async (tokenResponse) => {
      const responseActivateSubscription = await axios.patch(`${ADMIN_API_URL}/payments/paypal/subscription`, { 
                                          action: 'activate'
                                        }, 
                                        {
                                          headers: {
                                            Authorization: 'Bearer ' + tokenResponse.accessToken,
                                            cid: companyId,
                                          }
                                        })


      console.log("responseActivateSubscription", responseActivateSubscription)

      setIsLoadingActivateSubscription(false);
      getSubscriptionDetails(data.companyId)

      setShowSuccess(true);
    })
    .catch((error) => {
      //Acquire token silent failure, and send an interactive request
      console.log(error);

      setShowError(true);
      // instance.acquireTokenRedirect(silentRequest);
    });
  }

  async function companiesDetailsCreatedByList(oid) {

    // console.log('useEffect call!');

    let companiesDetailsCreatedByListEndpoint = ADMIN_API_URL + '/companies-details?createdByList=' + oid;
    console.log("companiesDetailsCreatedByListEndpoint: ", companiesDetailsCreatedByListEndpoint);

    instance
      .acquireTokenSilent({ ...silentRequest, account: account })
      .then(async (tokenResponse) => {
        // Do something with the tokenResponse
        console.log("Token response: ", tokenResponse);

        // Retrive companies details list
        const [responseCompaniesDetailsCreatedByList] = await Promise.all([
          axios
            .get(companiesDetailsCreatedByListEndpoint, {
              headers: {
                Authorization: 'Bearer ' + tokenResponse.accessToken,
              },
            })
            .catch((error) => console.log(error)),
        ]);
        console.log("responseCompaniesDetailsCreatedByList: ", responseCompaniesDetailsCreatedByList.data);


        if (responseCompaniesDetailsCreatedByList.data.length > 0) {

          let _companiesDetails = responseCompaniesDetailsCreatedByList.data[0];

          setCompaniesDetails(_companiesDetails);

          if (_companiesDetails?.enabled === true) {
            setEnabled('true');
          } else if (_companiesDetails?.enabled === false) {
            setEnabled('false');
          } else {
            setEnabled('-');
          }

          setBillingType(_companiesDetails?.billings?.type);

          if (_companiesDetails?.settings?.digitalSign === true) {
            setDigitalSign('true');
          } else {
            setDigitalSign('false');
          }

          if (_companiesDetails?.settings?.etax?.pdfa === true) {
            setPdfa('true');
          } else {
            setPdfa('false');
          }

          if (_companiesDetails?.settings?.etax?.attachXml === true) {
            setAttachXml('true');
          } else {
            setAttachXml('false');
          }

          if (_companiesDetails?.settings?.ltv === true) {
            setLtv('true');
          } else if (_companiesDetails?.settings?.ltv === false) {
            setLtv('false');
          } else {
            setLtv('-');
          }

          if (_companiesDetails?.settings?.signature?.visible === true) {
            setDigitallySignedBy('true');
          } else {
            setDigitallySignedBy('false');
          }

          if (_companiesDetails?.settings?.signature?.dateBE === true) {
            setDigitallySignedByBE('true');
          } else {
            setDigitallySignedByBE('false');
          }

          if (_companiesDetails?.settings?.enableSms === true) {
            setEnableSms('true');
          } else {
            setEnableSms('false');
          }

          // console.log("_companiesDetails?.settings?.etax?.serviceProvider?.id:", _companiesDetails?.settings?.etax?.serviceProvider?.id);

          if (_companiesDetails?.settings?.etax?.serviceProvider?.id === 'ginkgo-soft') {
            setServiceProvider('ginkgo-soft');
          } else if (_companiesDetails?.settings?.etax?.serviceProvider?.id === 'stream-it-consulting') {
            setServiceProvider('stream-it-consulting');
          } else {
            setServiceProvider('null');
          }

          if (_companiesDetails?.billings?.subscription) {
            setSelectedBillingSubscription('true');
          } else if (_companiesDetails?.billings?.subscription === false) {
            setSelectedBillingSubscription('false');
          } else {
            setSelectedBillingSubscription('-');
          }

          if (_companiesDetails?.billings?.manual) {
            setSelectedBillingManual('true');
          } else if (_companiesDetails?.billings?.manual === false) {
            setSelectedBillingManual('false');
          } else {
            setSelectedBillingManual('-');
          }

          // setIsLoading(false);
          setGetNewData(false);
          setIsLoadingGetNewData(false);

        }

      })
      .catch((error) => {
        //Acquire token silent failure, and send an interactive request
        console.log(error);
        // instance.acquireTokenRedirect(silentRequest);
      });

    

  }

  async function accountsOidList(oid) {

    console.log('useEffect call!');

    let accountsOidListEndpoint = ADMIN_API_URL + '/accounts?oidList=' + oid;
    console.log("accountsOidListEndpoint: ", accountsOidListEndpoint);

    instance
      .acquireTokenSilent({ ...silentRequest, account: account })
      .then(async (tokenResponse) => {
        // Do something with the tokenResponse
        console.log("Token response: ", tokenResponse);

        // Retrive companies details list
        const [responseAccountsOidList] = await Promise.all([
          axios
            .get(accountsOidListEndpoint, {
              headers: {
                Authorization: 'Bearer ' + tokenResponse.accessToken,
              },
            })
            .catch((error) => console.log(error)),
        ]);
        console.log("responseAccountsOidList: ", responseAccountsOidList.data);


        if (responseAccountsOidList.data.length > 0) {
          setAccountData(responseAccountsOidList.data[0]);
        }

      })
      .catch((error) => {
        //Acquire token silent failure, and send an interactive request
        console.log(error);
        // instance.acquireTokenRedirect(silentRequest);
      });

  }

  async function getPackage() {
    instance
    .acquireTokenSilent({ ...silentRequest, account: account })
    .then(async (tokenResponse) => {
      const responseCurrentPackage = await axios.get(`${ADMIN_API_URL}/packages/main?companyId=${companyId}`, {
                                                      headers: {
                                                        Authorization: 'Bearer ' + tokenResponse.accessToken,
                                                        'cid': companyId,
                                                      },
                                                    })


      console.log("responseCurrentPackage", responseCurrentPackage);

      if (responseCurrentPackage?.data) {
        setCurrentMainPackage(responseCurrentPackage.data);
        setSelectedPackageStatus(responseCurrentPackage.data.status || '-');
        setSelectedMainPackage(responseCurrentPackage.data.packageId || '');
        setMonthsRemaining(responseCurrentPackage.data.monthsRemaining);
      }


    
    }).catch((error) => {
      //Acquire token silent failure, and send an interactive request
      console.log("getPackageAndAccountDetail error", error);
      // instance.acquireTokenRedirect(silentRequest);
    });
  }

  async function getPackageAll() {
    instance
    .acquireTokenSilent({ ...silentRequest, account: account })
    .then(async (tokenResponse) => {
      const responsePackages = await axios.get(`${ADMIN_API_URL}/packages?packageType=main&type=document`, {
                                                      headers: {
                                                        Authorization: 'Bearer ' + tokenResponse.accessToken,
                                                        'cid': companyId,
                                                      },
                                                    })


      console.log("response getPackageAll", responsePackages);

      const sortPackage = responsePackages.data.packages.sort((a, b) => {
        if (a.packageId === "paper-main-1-months-5-documents-trial") return 1;
        if (b.packageId === "paper-main-1-months-5-documents-trial") return -1;
        
        if (a.packageId === "etax-main-1-months-5-documents-trial") return 1;
        if (b.packageId === "etax-main-1-months-5-documents-trial") return -1;

        if (a.etax !== b.etax) {
          return a.etax ? -1 : 1;
        }

        if (a.monthsLimit !== b.monthsLimit) {
          return a.monthsLimit === 1 ? -1 : 1;
        }

        return a.total - b.total;
      });

      console.log("sortPackage", sortPackage);

      const _packages = sortPackage.map(_package => ({
        key: _package.packageId,
        text: _package.descriptionTH.replace('ค่า Subscription ซอฟต์แวร์ Leceipt ', '').replace('(ต้นฉบับเอกสารเป็นกระดาษ)', '(กระดาษ)'),
        ..._package
      }));

      _packages.push({
        key: "paper-main-6-months-100-documents-otod",
        text: "OTOD AI ช่วยชาติ 100 เอกสาร 6 เดือน",
        packageId: "paper-main-6-months-100-documents-otod",
        total: 100,
        name: "ค่า Subscription ซอฟต์แวร์ Leceipt 6 เดือน (100 เอกสาร/เดือน)",
        descriptionTH: "ค่า Subscription ซอฟต์แวร์ Leceipt 6 เดือน (100 เอกสาร/เดือน)",
        descriptionEN: "6-Months Subscription for Leceipt Software (100 documents/month)",
        monthsLimit: 6,
        name: "ค่า Subscription ซอฟต์แวร์ Leceipt 6 เดือน (100 เอกสาร/เดือน)",
        promotions: {
          discount: {
            percent: 0,
            value: 0
          },
          additional: {
            total: 0
          },
          monthsLimit: 0
        },
        price: 5000,
        type: "document",
        additionalPrice: 10,
        etax: false
      });

      setPackages(_packages);

    
    }).catch((error) => {
      //Acquire token silent failure, and send an interactive request
      console.log("getPackageAndAccountDetail error", error);
      // instance.acquireTokenRedirect(silentRequest);
    });
  }

  async function getCurrentPackageAddOn() {
    instance
    .acquireTokenSilent({ ...silentRequest, account: account })
    .then(async (tokenResponse) => {
      const responsePackages = await axios.get(`${ADMIN_API_URL}/packages/add-ons?status=active`, {
                                                      headers: {
                                                        Authorization: 'Bearer ' + tokenResponse.accessToken,
                                                        'cid': companyId,
                                                        // 'cid': 'c8d1bf6b-bf74-4608-ae46-34a282990e13',
                                                      },
                                                    })


      console.log("responseCurrentPackagesAddOn", responsePackages);

      const isoTimeNow = new Date().toISOString();

      const _packages = responsePackages.data.packages.filter(_package => _package.to >= isoTimeNow);
      setCurrentAddOnPackages(_packages);

    
    }).catch((error) => {
      //Acquire token silent failure, and send an interactive request
      console.log("getPackageAndAccountDetail error", error);
      // instance.acquireTokenRedirect(silentRequest);
    });
  }

  async function getPackageAddOnAll() {
    instance
    .acquireTokenSilent({ ...silentRequest, account: account })
    .then(async (tokenResponse) => {
      const responsePackages = await axios.get(`${ADMIN_API_URL}/packages?packageType=addOn`, {
                                                      headers: {
                                                        Authorization: 'Bearer ' + tokenResponse.accessToken,
                                                        'cid': companyId,
                                                        // 'cid': 'c8d1bf6b-bf74-4608-ae46-34a282990e13',
                                                      },
                                                    })


      console.log("responsePackagesAddOn", responsePackages);

      const _packages = responsePackages.data.packages.map(_package => ({
        key: _package.packageId,
        text: _package.name
      }));
      setPackagesAddOns(_packages);

    
    }).catch((error) => {
      //Acquire token silent failure, and send an interactive request
      console.log("getPackageAndAccountDetail error", error);
      // instance.acquireTokenRedirect(silentRequest);
    });
  }

  return (
    <>
      <div style={homeStyles}>

        {showSuccess && (
          <MessageBar
            messageBarType={MessageBarType.success}
            isMultiline={false}
            onDismiss={() => setShowSuccess(false)}
            dismissButtonAriaLabel="Close"
            style={{
              fontSize: 14,
            }}
          >
            บันทึกสำเร็จ! โดยรอประมาณ 10 วินาที จากนั้นให้รีเฟรชหน้าจอใหม่
          </MessageBar>
        )}
        {showError && (
          <MessageBar
            messageBarType={MessageBarType.error}
            isMultiline={false}
            onDismiss={() => setShowError(false)}
            dismissButtonAriaLabel="Close"
            style={{
              fontSize: 14,
            }}

          >
            บันทึกไม่สำเร็จ!
          </MessageBar>
        )}


        <Stack horizontal horizontalAlign="center">
          <Stack
            vertical
            style={{
              width: '80%',
              maxWidth: '500px',
            }}>
            <h1 style={{ marginLeft: '0px', marginTop: '27px' }} ><Icon iconName="CityNext2" style={{ color: '#106ebe' }} /> ตั้งค่าบริษัท</h1>
            {/* <h3 style={{ marginTop: '0px', marginBottom: '10px' }} >{data.companyName}</h3> */}
            {/* <br/> */}
            companyId: {data.companyId}
            <br />
            ชื่อบริษัท: {data.companyName}
            <br />
            อีเมล: {data.email}
            <br />
            <br />

            oid: {data.oid}
            <br />
            อีเมลเข้าสู่ระบบ: {accountData.profiles?.email}
            <br />
            ชื่อ: {accountData.profiles?.firstName} {accountData.profiles?.lastName}
            <br />
            เบอร์โทร: {accountData.profiles?.mobile}
            <br />
            <br />
            {/*                 เครดิตเอกสาร: {credits}
                <br/>
                เติมล่าสุด: {lastTopup}
                <br/>
                เวลาเติมล่าสุด: {lastTopupTime}                                
                <br/>
                <br/>
 */}
            {!isLoadingGetNewData && (
              <div style={cardStyle}>
                <Stack >
                  <Stack horizontal horizontalAlign="start" tokens={{ childrenGap: "30px" }}>

                    <DefaultButton
                      iconProps={{ iconName: "Refresh" }}
                      style={{ marginTop: "5px", marginBottom: "5px" }}
                      disabled={isLoadingGetNewData}
                      onClick={() => {
                        setGetNewData(true);
                        setIsLoadingGetNewData(true);
                      }}
                      text="รีเฟรช" />

                  </Stack>

                  <Separator />
                  <Stack horizontal horizontalAlign="start" tokens={{ childrenGap: "30px" }} style={{ marginBottom: "10px", }}>
                    {subscriptionDetails ? (
                      <Stack style={{ width: 440 }}>
                        <Stack horizontal horizontalAlign='space-between'>
                          <Stack><strong>สถานะ:</strong></Stack>
                          <Stack>{subscriptionDetails.status}</Stack>
                        </Stack>
                        <Stack horizontal horizontalAlign='space-between'>
                          <Stack><strong>จาก:</strong></Stack>
                          <Stack>{subscriptionDetails.provider}</Stack>
                        </Stack>
                        <Stack horizontal horizontalAlign='space-between'>
                          <Stack><strong>Subscription ID:</strong></Stack>
                          <Stack>{subscriptionDetails.providerSubscriptionId}</Stack>
                        </Stack>
                        <Stack horizontal horizontalAlign='space-between'>
                          <Stack><strong>จำนวนชำระไม่สำเร็จ:</strong></Stack>
                          <Stack>{subscriptionDetails.retryAttempts}</Stack>
                        </Stack>
                        <Stack horizontal horizontalAlign='space-between'>
                          <Stack><strong>แพ็กเกจปัจจุบัน:</strong></Stack>
                          <Stack>{subscriptionDetails.packageId}</Stack>
                        </Stack>
                        <Stack horizontal horizontalAlign='space-between'>
                          <Stack><strong>แพ็กเกจที่จะเปลี่ยน:</strong></Stack>
                          <Stack>{subscriptionDetails.newPackageId}</Stack>
                        </Stack>
                        <Stack horizontal horizontalAlign='space-between'>
                          <Stack><strong>ใบแจ้งหนี้ปัจจุบัน:</strong></Stack>
                          <Stack>{subscriptionDetails.currentBillingId}</Stack>
                        </Stack>
                        <Stack horizontal horizontalAlign='space-between'>
                          <Stack><strong>ลิงค์สำหรับอนุมัติ:</strong></Stack>
                          <Stack>{subscriptionDetails.link}</Stack>
                        </Stack>
                        <Stack horizontal horizontalAlign='space-between'>
                          <Stack><strong>วันที่หักเงินถัดไป:</strong></Stack>
                          <Stack>{onFormatDate(new Date(subscriptionDetails.nextBillingTime), "BE")}</Stack>
                        </Stack>
                      </Stack>

                    ) : null}
                  </Stack>

                  <Stack horizontal horizontalAlign="start" tokens={{ childrenGap: "30px" }} style={{ marginBottom: "10px", width: 440 }}>
                    {subscriptionDetails ? (
                      <CodeMirror
                        value={JSON.stringify(subscriptionDetails.payload, null, 2)}
                        options={{
                            //mode: 'javascript',
                            mode: {
                                name: "javascript",
                                json: true,
                                statementIndent: 2
                            },
                            theme: 'material',
                            //lineNumbers: true,
                            lineNumbers: true,
                            lineWrapping: true,
                            indentWithTabs: false,
                            tabSize: 2,
                            viewportMargin: Infinity,
                        }}  
                    />  

                    ) : null}
                      

                  </Stack>
                  <Stack horizontal  horizontalAlign="space-between" tokens={{ childrenGap: "30px" }} style={{ marginBottom: "10px", width: 440 }}>
                    <div>
                      <Dropdown
                        // placeholder="Select an option"
                        label="แพ็กเกจที่ต้องการเปลี่ยน:"
                        // style={{ width: "150px" }}
                        styles={dropdownStyles}
                        options={packages}
                        selectedKey={selectedMainPackage}
                        // styles={dropdownStyles}
                        onChange={(e, selectedOption) => {
                          console.log(selectedOption);
                          setSelectedMainPackage(selectedOption.key);
                        }}
                      />
                      <Stack styles={{ root: {fontSize: 14}}}>Plan ID: <strong>{packages.length ? packages.find(_package => _package.key === selectedMainPackage)?.payments?.paypal?.plan?.id : ""}</strong></Stack>
                    </div>

                    {!isLoadingChangePackage &&
                      <DefaultButton
                        style={{ marginTop: "28px", width: 155 }}
                        onClick={() => setDialog({
                          isClick: true,
                          title: "ยืนยันเปลี่ยนแพ็กเกจ",
                          onSubmit: () => handleChangePackage(),
                          cooldown: 10
                        })}
                        text="เปลี่ยนแพ็กเกจ" />
                    }
                    {isLoadingChangePackage &&
                      <Spinner styles={spinnerStyles} />

                    }
                  </Stack>
                  <Stack horizontal horizontalAlign="space-between" tokens={{ childrenGap: "30px" }} style={{ marginBottom: "10px", width: 440 }}>
                    
                        <Stack verticalAlign='center'>หยุดแพ็กเกจชั่วคราว</Stack>

                        {!isLoadingSuspendSubscription &&
                          <DefaultButton
                            style={{ width: 155 }}
                            onClick={() => setDialog({
                              isClick: true,
                              title: "ยืนยันหยุดแพ็กเกจชั่วคราว",
                              onSubmit: () => handleSuspendSubscription(),
                              cooldown: 10
                            })}
                            text="หยุดชั่วคราว" />
                        }
                        {isLoadingSuspendSubscription &&
                          <Spinner styles={spinnerStyles} />
    
                        }

                  </Stack>
                  <Stack horizontal horizontalAlign="space-between" tokens={{ childrenGap: "30px" }} style={{ marginBottom: "10px", width: 440 }}>
                    
                        <Stack verticalAlign='center'>ใช้งานแพ็กเกจต่อ</Stack>

                        {!isLoadingActivateSubscription &&
                          <DefaultButton
                            style={{ width: 155 }}
                            onClick={() => setDialog({
                              isClick: true,
                              title: "ยืนยันใช้แพ็กเกจต่อ",
                              onSubmit: () => handleActivateSubscription(),
                              cooldown: 10
                            })}
                            text="ใช้งานแพ็กเกจต่อ" />
                        }
                        {isLoadingActivateSubscription &&
                          <Spinner styles={spinnerStyles} />
    
                        }

                  </Stack>
                  <Stack horizontal horizontalAlign="space-between" tokens={{ childrenGap: "30px" }} style={{ marginBottom: "10px", width: 440 }}>
                   
                        <Stack verticalAlign='center'>ยกเลิกแพ็กเกจ</Stack>

                        {!isLoadingCancelSubscription &&
                          <DefaultButton
                            style={{ width: 155 }}
                            onClick={() => setDialog({
                              isClick: true,
                              title: "ยืนยันยกเลิกแพ็กเกจถาวร",
                              onSubmit: () => handleCancelSubscription(),
                              cooldown: 10
                            })}
                            text="ยกเลิกแพ็กเกจ" />
                        }
                        {isLoadingCancelSubscription &&
                          <Spinner styles={spinnerStyles} />
    
                        }

                  </Stack>
                  <br />

                


                </Stack>
              </div>
            )}
            <br />
            <br />
            <br />

          </Stack>
        </Stack>

        <Dialog
          hidden={!dialog.isClick}
          onDismiss={() =>
            setDialog((prev) => ({
              ...prev,
              isClick: false,
              title: "",
              onSubmit: () => null,
              cooldown: 10
            }))
          }
          styles={{ main: { minHeight: 0 } }}
          dialogContentProps={{
            type: DialogType.largeHeader,
            title: dialog.title,
            styles: { header: { textAlign: 'center' }, title: { paddingRight: 24 }, subText: { textAlign: 'center' } },
          }}
        >
          <DialogFooter styles={{ actionsRight: { textAlign: 'center' } }}>
            <PrimaryButton disabled={dialog.cooldown > 0 ? true : false} text={dialog.cooldown > 0 ? dialog.cooldown : "ยืนยัน"} onClick={() => dialog.onSubmit()} />
            <DefaultButton
              onClick={() =>
                setDialog((prev) => ({
                  ...prev,
                  isClick: false,
                  title: "",
                  onSubmit: () => null,
                  cooldown: 10
                }))
              }
              text="ยกเลิก"
            />
          </DialogFooter>
        </Dialog>


        {isLoadingGetNewData && (
          <Stack>
            <br />
            <br />
            <br />
            <Stack horizontal horizontalAlign="center">
              <div className="certificates-loading-center">
                <Spinner
                  label="กำลังโหลด..."
                  labelPosition="down"
                  styles={spinnerStylesLoading}
                />
              </div>
              <br />
            </Stack>
          </Stack>
        )}
      </div>
    </>
  );

}

export default SubscriptionsDetails;